export class SessionExpiredError extends Error {
    constructor(message?: string) {
        super(message);
        Object.setPrototypeOf(this, SessionExpiredError.prototype);
    }
}